module.exports = __webpack_public_path__ + "ac606833cdcf0da0803709ac75c75036.svg";